module.exports = __webpack_public_path__ + "static/media/call-img.d59ddc93.jpg";